/**
 * rc-tree / Antd 4 Tree — correções mínimas de a11y (axe / AccessMonitor):
 * 1) <input> focável sem nome dentro de role="tree"
 * 2) role="tree" num div interno que só tem o input
 * 3) região com scroll (list virtualizada) focável por teclado (scrollable_02)
 *
 * Sem MutationObserver em attributes; sem patch em cada treenode (freeze).
 */
export function bindAntTreeInputA11y(rootEl, ariaLabel = 'Navegação em árvore') {
  if (!rootEl) {
    return () => {};
  }

  let syncing = false;

  const setAttrIfNeeded = (el, name, value) => {
    if (el.getAttribute(name) !== value) {
      el.setAttribute(name, value);
    }
  };

  const removeAttrIfPresent = (el, name) => {
    if (el.hasAttribute(name)) {
      el.removeAttribute(name);
    }
  };

  const sync = () => {
    if (syncing) {
      return;
    }
    const antTree = rootEl.querySelector('.ant-tree');
    if (!antTree) {
      return;
    }

    syncing = true;
    try {
      const inputs = rootEl.querySelectorAll(
        '.ant-tree input, [role="tree"] > input, [role="tree"] input'
      );
      inputs.forEach(input => {
        setAttrIfNeeded(input, 'aria-hidden', 'true');
        setAttrIfNeeded(input, 'tabindex', '-1');
        removeAttrIfPresent(input, 'aria-label');
      });

      antTree.querySelectorAll(':scope > div[role="tree"]').forEach(inner => {
        setAttrIfNeeded(inner, 'role', 'presentation');
        removeAttrIfPresent(inner, 'aria-label');
      });

      setAttrIfNeeded(antTree, 'role', 'tree');
      setAttrIfNeeded(antTree, 'aria-label', ariaLabel);

      // Virtual list / holder com overflow — precisa ser focável (scrollable_02)
      antTree
        .querySelectorAll('.ant-tree-list-holder, .ant-tree-list')
        .forEach(holder => {
          setAttrIfNeeded(holder, 'tabindex', '0');
        });
    } finally {
      syncing = false;
    }
  };

  sync();

  const observer = new MutationObserver(() => {
    if (syncing) {
      return;
    }
    sync();
  });
  observer.observe(rootEl, {
    childList: true,
    subtree: true,
  });

  return () => observer.disconnect();
}
